export default {
    "我的个人主页": "我的个人主页",
    "视频管理": "视频管理",
    "历史记录": "历史记录",
    "认证管理": "认证管理",
    "账户设置": "账户设置",
    "还没有关注频道": "还没有关注频道",
    "还没有创建频道": "还没有创建频道",
    "账号与安全": "账号与安全",
    "语言": "语言",
    "已通过": "已通过",
    "未通过": "未通过",
    "请输入视频名称搜索": "请输入视频名称搜索",
    "全部视频": "全部视频",
    "视频": "视频",
    "状态": "状态",
    "创作时间": "创作时间",
    "上传时间": "上传时间",
    "操作": "操作",
    "审核中": "审核中",
    "不公开": "不公开",
    "公开": "公开",
    "去填写": "去填写",
    "编辑": "编辑",
    "更多": "更多",
    "获取链接": "获取链接",
    "评论管理": "评论管理",
    "下载": "下载",
    "删除": "删除",
    "视频链接": "视频链接",
    "复制": "复制",
    "嵌入代码": "嵌入代码",
    "是否永久删除该作品？": "是否永久删除该作品？",
    "编辑创作时间": "编辑创作时间",
    "删除作品": "删除作品",
    "清除历史记录": "清除历史记录",
    "视频评论": "视频评论",
    "删除作品": "删除作品",
    "编辑创作时间": "编辑创作时间",
    "未知": "未知",
    "筛选视频": "筛选视频",
    "批量删除": "批量删除",
    "删除评论": "删除评论",
    "共x条": "共{count}条",
    "已选x条": "已选{count}条",
    "是否永久删除该评论？": "是否永久删除该评论？",
    "没有评论": "没有评论",
    "此视频暂不公开": "此视频暂不公开",
    "还没有视频": "还没有视频",
    "去上传视频": "去上传视频",
}


// WEBPACK FOOTER //
// ./src/languages/cn/people.js